var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfoPage',{attrs:{"body":"info.communeaccepted.body","title":"info.communeaccepted.title"}})}
var staticRenderFns = []

export { render, staticRenderFns }